import { render, staticRenderFns } from "./coach-subpage.vue?vue&type=template&id=8e98a56c&lang=pug&"
import script from "./coach-subpage.vue?vue&type=script&lang=js&"
export * from "./coach-subpage.vue?vue&type=script&lang=js&"
import style0 from "./coach-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports